import React from "react";
import { Box, Typography } from "@mui/material";

const loadingAnimStyles = `
@keyframes gentlePulse {
  0% { transform: scale(0.95); opacity: 0.7; }
  50% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.7; }
}
`;

const LoadingScreen = ({ message = "Loading..." }) => (
  <>
    <style>{loadingAnimStyles}</style>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        bgcolor: '#fff',
        borderRadius: '12px',
        border: '1.5px solid #f1f5f9',
        boxShadow: '0 2px 10px rgba(15,23,42,0.06)',
      }}
    >
      <Box
        component="img"
        src="/logo512.png"
        alt="Loading"
        sx={{
          width: 120,
          height: 'auto',
          animation: 'gentlePulse 1.5s ease-in-out infinite',
        }}
      />
      <Typography variant="body2" sx={{ color: '#64748b', mt: 2, fontWeight: 500 }}>
        {message}
      </Typography>
    </Box>
  </>
);

export default LoadingScreen;